import React from 'react';
import ReactDOM from 'react-dom';
import './Popup.style.css';
import HtmlContent from '../HtmlContent';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Navigation } from 'swiper/modules';
import { removeCookie } from 'utils';

const Popup = ({ isOpen = false, data = [], onClose }) => {
  /* ===== Route ===== */
  /* ===== Props ===== */
  /* ===== State ===== */
  const nextRef = React.useRef(null);
  const prevRef = React.useRef(null);
  const [swiper, setSwiper] = React.useState(null);
  const [activeIndex, setActiveIndex] = React.useState(0);

  /* ===== Hooks ===== */
  /* ===== Function ===== */
  const handleRedirect = (url = '', type = 'N') => {
    if (!url) return;

    if (type === 'Y') {
      window.open(url);
    } else {
      window.location.href = url;
    }
  };

  /* ===== Variable ===== */
  /* ===== Hooks ===== */
  /* ===== Render ===== */
  if (!isOpen) return null;

  return ReactDOM.createPortal(
    <div className="popup-overlay">
      <div className="popup-container">
        <div className="popup-content">
          <Swiper
            slidesPerView={1}
            className="main_banner_swiper"
            autoplay={{
              delay: 3000,
              disableOnInteraction: false,
            }}
            modules={[Autoplay, Navigation]}
            loop={true}
            onInit={(swiper) => {
              swiper.params.navigation.prevEl = prevRef.current;
              swiper.params.navigation.nextEl = nextRef.current;
              swiper.navigation.init();
              swiper.navigation.update();
              setSwiper(swiper);
            }}
            onSlideChange={(sw) => setActiveIndex(sw?.realIndex)}
          >
            {data.map((popup) => (
              <SwiperSlide key={`popup-${popup.popup_id}`}>
                <div
                  className={`popup-content-wrap ${
                    popup.render_url ? 'popup-content-wrap-active' : ''
                  }`}
                  onClick={() =>
                    handleRedirect(popup.render_url, popup.is_new_window)
                  }
                >
                  <HtmlContent content={popup.popup_content} />
                </div>
              </SwiperSlide>
            ))}
          </Swiper>

          <div className="popup-swiper-controller">
            <button onClick={() => swiper.slidePrev()}>{'<'}</button>
            <p>
              {activeIndex + 1} / {data.length}
            </p>
            <button onClick={() => swiper.slideNext()}>{'>'}</button>
          </div>
        </div>
        <div className="popup-button-wrap">
          <button
            onClick={() => {
              removeCookie(
                'jm-popup-visible',
                'invisible',
                24 * 60 * 60 * 1000
              );
              onClose();
            }}
          >
            24시간동안 보지않기
          </button>
          <button onClick={() => onClose()}>닫기</button>
        </div>
      </div>
    </div>,
    document.body
  );
};

export default Popup;
